import React, { useMemo } from 'react';
import SubPage from '#/common/components/SubPage';
import AssetTypeForm, { SubmitAssetType } from '../components/AssetTypeForm';
import type { AssetType } from '#/graphql/types';
import { createFields } from '../components/AssetTypeForm/fields';
import useCreateAssetTypeMutation from '../hooks/useCreateAssetTypeMutation';
import useSession from '#/common/hooks/useSession';

const NewAssetTypePage: React.FC = () => {
  const { user, loading } = useSession();
  const title = 'New Asset Type';

  const newAssetType = useMemo(() => {
    return {
      __typename: 'AssetType',
      createdAt: new Date().toISOString(),
      createdBy: user?.id,
    } as AssetType;
  }, [user]);

  const { createAssetType } = useCreateAssetTypeMutation() as { createAssetType: SubmitAssetType };

  return (
    <SubPage title={title} showGoBackButton type="form">
      {loading ? null : (
        <AssetTypeForm
          title={title}
          assetType={newAssetType}
          fields={createFields}
          submit={createAssetType}
        />
      )}
    </SubPage>
  );
};

export default React.memo(NewAssetTypePage);
